<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-5xl mx-auto">
      
      <!-- HEADER -->
      <div class="sci-page-header pb-4">
        <div>
          <button @click="$router.back()" class="flex items-center gap-2 text-slate-500 hover:text-orange-600 transition-colors mb-4 self-start">
            <v-icon small color="inherit">mdi-arrow-left</v-icon>
            <span class="text-[10px] font-bold uppercase tracking-wider">Voltar</span>
          </button>
          <h1 class="sci-page-header-title">{{ id ? 'Editar Cliente' : 'Cadastrar novo Cliente' }}</h1>
          <p class="text-sm text-slate-500">Preencha as informações abaixo para gerenciar o portador do cartão black</p>
        </div>
      </div>

      <v-form @submit.prevent="save">
        <div class="space-y-6">
          <!-- CARD: DADOS DO CLIENTE -->
          <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
            <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
              <v-icon color="orange" small>mdi-account-details-outline</v-icon>
              <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">DADOS CADASTRAIS</h2>
            </div>
            
            <div class="p-8">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Prefeitura Vinculada -->
                <div class="md:col-span-2">
                  <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Prefeitura Vinculada</label>
                  <v-autocomplete
                    v-model="clientData.prefecture_id"
                    :items="prefectures"
                    item-text="prefecture_social_name"
                    item-value="prefecture_id"
                    placeholder="Busque a prefeitura..."
                    outlined
                    dense
                    hide-details
                    class="custom-input"
                  />
                </div>

                <!-- Nome Completo -->
                <div>
                  <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Nome Completo</label>
                  <v-text-field
                    v-model="clientData.client_name"
                    placeholder="Ex: João da Silva"
                    outlined
                    dense
                    hide-details
                    class="custom-input uppercase"
                  />
                </div>

                <!-- Documento -->
                <div>
                  <label class="block text-[10px] font-bold uppercase text-slate-500 mb-1">Documento (CPF/CNPJ)</label>
                  <v-text-field
                    v-model="clientData.client_document"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                    placeholder="000.000.000-00"
                    outlined
                    dense
                    hide-details
                    class="custom-input"
                  />
                </div>
              </div>
            </div>

            <!-- FOOTER DENTRO DO CARD -->
            <div class="bg-slate-50 px-8 py-5 border-t border-slate-200 flex justify-end items-center gap-4">
              <button 
                type="button"
                @click="$router.back()"
                class="text-slate-500 hover:text-slate-700 font-bold text-[11px] uppercase px-4 py-2 transition-colors flex-none"
              >
                Cancelar
              </button>
              <div class="flex-none">
                <button
                  type="submit"
                  :disabled="loader"
                  class="bg-orange-500 hover:bg-orange-600 text-white font-bold text-[11px] px-8 py-2.5 rounded shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all w-auto max-w-max whitespace-nowrap flex items-center gap-2"
                >
                  <v-icon small color="white">mdi-check</v-icon>
                  <span v-if="loader" class="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></span>
                  <span v-else>{{ id ? 'SALVAR ALTERAÇÕES' : 'CONFIRMAR CADASTRO' }}</span>
                </button>
              </div>
            </div>
          </section>
        </div>
      </v-form>
    </div>

    <!-- Feedback -->
    <v-snackbar v-model="snack.show" :color="snack.color" timeout="3000" top right>
      <div class="flex items-center gap-3">
        <v-icon color="white" small>{{ snack.color === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
        <span class="text-[11px] font-bold uppercase tracking-wider">{{ snack.message }}</span>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data: () => ({
    loader: false,
    prefectures: [],
    clientData: {
      client_id: null,
      client_name: "",
      client_document: "",
      prefecture_id: null
    },
    snack: {
      show: false,
      message: "",
      color: "success"
    }
  }),
  created() {
    this.fetchPrefectures();
    if (this.id) {
       this.fetchClient();
    }
  },
  methods: {
    fetchPrefectures() {
      this.$http.get("/prefectures").then(r => {
        this.prefectures = r.data;
      });
    },
    fetchClient() {
      this.$store.dispatch("setLoader", true);
      this.$http.get("/settings/black-cards/clients").then(r => {
        const client = r.data.find(c => c.client_id == this.id);
        if (client) {
          this.clientData = { ...client };
        }
        this.$store.dispatch("setLoader", false);
      }).catch(e => {
        this.$store.dispatch("setLoader", false);
        console.error(e);
      });
    },
    save() {
      if (!this.clientData.client_name || !this.clientData.prefecture_id) {
         this.snack.show = true;
         this.snack.message = "Preencha os campos obrigatórios!";
         this.snack.color = "warning";
         return;
      }

      this.loader = true;
      this.$store.dispatch("setLoader", true);
      
      const url = this.id 
        ? `/settings/black-cards/clients/${this.id}` 
        : "/settings/black-cards/clients";
      
      const method = this.id ? 'put' : 'post';

      this.$http[method](url, this.clientData).then(r => {
        this.snack.show = true;
        this.snack.message = r.data.result;
        this.snack.color = "success";
        this.loader = false;
        this.$store.dispatch("setLoader", false);
        setTimeout(() => {
          this.$router.push("/settings/black-cards/clients");
        }, 1000);
      }).catch(e => {
        this.snack.show = true;
        this.snack.message = e.message;
        this.snack.color = "error";
        this.loader = false;
        this.$store.dispatch("setLoader", false);
      });
    }
  }
};
</script>

<style scoped>
.custom-input >>> .v-input__slot {
  background-color: #f8fafc !important;
  border-radius: 8px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: none !important;
}
</style>
